import React, { useCallback, useEffect } from 'react';
import { useExpressCheckoutButtonsData } from '../provider/useExpressCheckoutButtonsData';
import loadable from '@loadable/component';
import { useFunctionResultObservation } from '@wix/function-result-observation';
import { RESULT_PROP_NAME } from '../utils/consts';
import { getEstimatedPaymentData } from '../utils/getEstimatedPaymentData';
const CashierExpressCheckoutWidgetLazy = loadable({
  resolved: {},
  chunkName() {
    return "CashierExpressCheckoutWidget";
  },
  isReady(props) {
    const key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: () => import(/* webpackChunkName: "CashierExpressCheckoutWidget" */'@wix/cashier-express-checkout-widget'),
  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync(props) {
    const id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@wix/cashier-express-checkout-widget");
    }
    return eval('require.resolve')("@wix/cashier-express-checkout-widget");
  }
}, {
  resolveComponent: components => components.CashierExpressCheckoutWidget
});
export let ExpressCheckoutButtonsDataHooks = /*#__PURE__*/function (ExpressCheckoutButtonsDataHooks) {
  ExpressCheckoutButtonsDataHooks["root"] = "ExpressCheckoutButtonsDataHooks.root";
  return ExpressCheckoutButtonsDataHooks;
}({});
export const ExpressCheckoutButtons = _ref => {
  let {
    layout,
    theme,
    buttonStyle,
    isShippable,
    estimatedTotal = '0',
    canStartPayment = true,
    dataHook,
    currency
  } = _ref;
  const data = useExpressCheckoutButtonsData();
  const {
    withObservation
  } = useFunctionResultObservation({
    resultPropName: RESULT_PROP_NAME
  });
  const {
    legacyCurrency,
    locale,
    domain,
    meta,
    demoMode,
    onCancel,
    onClick,
    setCurrency,
    isExpressSupported
  } = data ?? {};
  useEffect(() => {
    if (currency && setCurrency) {
      setCurrency(currency);
    }
  }, [currency, setCurrency]);
  const onShippingContactSelected = withObservation(data, 'onShippingContactSelected');
  const onPaymentAuthorized = withObservation(data, 'onPaymentAuthorized');
  const onShippingMethodSelected = withObservation(data, 'onShippingMethodSelected');
  const getInitialPaymentData = withObservation(data, 'getInitialPaymentData');
  const onPaymentMethodsInit = withObservation(data, 'onPaymentMethodsInit');
  const onClickHandler = useCallback(() => {
    onClick();
    return {
      canceled: !canStartPayment
    };
  }, [canStartPayment, onClick]);
  if (!data) {
    return null;
  }
  const {
    orderItems,
    paymentBreakdown,
    paymentAmount
  } = getEstimatedPaymentData(estimatedTotal);
  if (Number(paymentAmount) === 0 || !isExpressSupported) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHook ?? ExpressCheckoutButtonsDataHooks.root,
    "data-wix-hideable": true
  }, /*#__PURE__*/React.createElement(CashierExpressCheckoutWidgetLazy, {
    currency: currency ?? legacyCurrency,
    demoMode: demoMode,
    theme: theme,
    buttonStyle: buttonStyle,
    layout: layout,
    locale: locale,
    domain: domain,
    meta: meta,
    paymentLabel: "forApplePay",
    orderItems: orderItems,
    requestShipping: isShippable,
    paymentBreakdown: paymentBreakdown,
    paymentAmount: paymentAmount,
    onPaymentMethodsAmountInit: onPaymentMethodsInit,
    onPaymentAuthorized: paymentInfo => onPaymentAuthorized(paymentInfo, isShippable),
    onCancel: () => onCancel(),
    onClick: onClickHandler,
    onShippingMethodSelected: shippingMethod => onShippingMethodSelected(shippingMethod),
    onShippingContactSelected: shippingContact => onShippingContactSelected(shippingContact),
    getInitialPaymentData: () => getInitialPaymentData()
  }));
};
//# sourceMappingURL=ExpressCheckoutButtons.js.map